import cx from "classnames";

interface RadioProps {
  label?: string;
  checked?: boolean;
  name: string;
  disabled?: boolean;
  invalid?: boolean;
  "data-testid"?: string;
  onChange?: (value: boolean) => void;
  height?: string;
  labelClassName?: string;
}

export const Radio = ({
  label,
  checked,
  disabled,
  invalid,
  name,
  "data-testid": dataTestId,
  height = "h-9",
  onChange,
  labelClassName,
}: RadioProps) => {
  return (
    <label className={`flex ${height} items-center`}>
      <input
        checked={checked}
        className={cx(
          "m-2.5 h-6 w-6 rounded-xl border border-solid border-brand-color bg-white text-brand-color ring-0 ring-transparent focus:ring-0 focus:ring-transparent aria-invalid:ring-1 aria-invalid:placeholder:text-red",
          disabled ? "cursor-not-allowed opacity-40" : "cursor-pointer"
        )}
        data-testid={dataTestId}
        disabled={disabled}
        name={name}
        type="radio"
        aria-invalid={invalid}
        onChange={(e) => onChange?.(e.target.checked)}
      />
      {label && (
        <div
          className={cx(
            "ml-1.5 text-primary",
            labelClassName,
            disabled ? "cursor-not-allowed opacity-40" : "cursor-pointer"
          )}
        >
          {label}
        </div>
      )}
    </label>
  );
};
